<script>
  import { format } from 'svelte-i18n';

  import { LazyLoad } from '@client/components/lazy-load';
  import { Table } from '@client/components/table';

  import { activeDomain } from '@client/stores/domain-settings';

  import PushedSignature from './pushed-signature.svelte';
  import StatusCell from './status-cell.svelte';

  export let fields = [];
  export let results = [];
  export let rows = [];
  export let type;

  // Removes empty columns:
  $: filteredFields = fields.filter((header) => header?.length);

  $: status = results.reduce((lookup, next) => {
    return {
      ...lookup,
      [next.username]: {
        error: !next.success,
        ...next
      }
    };
  }, {});

  $: columns = [
    {
      key: 'status',
      title: $format('label.STATUS'),
      value: (row) => status[row.username],
      renderComponent: {
        component: StatusCell,
        props: {
          error: (row) => status[row.username]?.error,
          success: (row) => status[row.username]?.success,
          tooltip: (row) => status[row.username]?.message
        }
      }
    },
    ...filteredFields.map((field) => {
      return {
        key: field,
        title: field,
        value: (row) => row[field],
        sortable: true
      };
    })
  ];

  $: showSignature = type !== 'email';
</script>

<Table bind:columns bind:rows expandRowKey="username" showExpandAll showExpandIcon={showSignature} size="sm">
  <div slot="expanded" let:row>
    <LazyLoad>
      <PushedSignature email="{row.username}@{$activeDomain}" {type} />
    </LazyLoad>
  </div>
</Table>

<style lang="scss" src="./status-table.scss"></style>
